import { useLocalStorage } from '@mantine/hooks';
import { useCallback } from 'react';

export function useFullWidthToggle(entityId?: string) {
	const [shouldSetFullWidth, setValue, removeValue] = useLocalStorage({
		key: `fullWidthToggle-${entityId}`,
		defaultValue: false,
	});

	const toggle = useCallback(() => {
		const newValue = !shouldSetFullWidth;

		if (newValue === false) {
			removeValue();
			return;
		}

		setValue(newValue);
	}, [removeValue, setValue, shouldSetFullWidth]);

	return {
		shouldSetFullWidth,
		toggle,
	};
}
